export default __webpack_public_path__ + "static/media/richard_di_natale.af6894c7.jpg";